import React from "react";
import { isAfter } from "@hex-insights/core";
import { ClassYearLookupQuery, useClassYearLookupQuery } from "../../../Utilities";

export function useClassYear(yearsFromGraduation: number) {
	const { loading, data } = useClassYearLookupQuery();

	if (!data) {
		return { loading, classYear: null };
	}
	return {
		loading,
		classYear:
			data.classYearConnection.edges.find(({ node }) => node.yearsFromGraduation === yearsFromGraduation)?.node ?? null,
	};
}

export function useClassYearsMap() {
	const { loading, data } = useClassYearLookupQuery();

	const classYears = React.useMemo(() => {
		if (!data) {
			return {};
		}

		const classYears: Record<number, ClassYearLookupQuery["classYearConnection"]["edges"][0]["node"]> = {};
		for (let i = 0; i < data.classYearConnection.edges.length; i++) {
			const classYear = data.classYearConnection.edges[i].node;
			classYears[classYear.graduationYear] = classYear;
		}

		return classYears;
	}, [data]);

	return { loading, data, classYears };
}

// Should match backend/server/ent/computed_utils.go
export function graduationYearFromYearsFromGraduation(yearsFromGraduation: number, date = new Date()) {
	const year = date.getFullYear();
	const academicYearCutoff = new Date(year, 7, 15, 0, 0, 0, 0);
	let graduationYear = year + yearsFromGraduation;
	const isFallTerm = isAfter(date, academicYearCutoff);
	if (isFallTerm) {
		graduationYear++;
	}
	return graduationYear;
}

// Should match backend/server/ent/computed_utils.go
export function yearsFromGraduationFromGraduationYear(graduationYear: number, date = new Date()) {
	const year = date.getFullYear();
	const academicYearCutoff = new Date(year, 7, 15, 0, 0, 0, 0);
	let yearsFromGraduation = graduationYear - year;
	const isFallTerm = isAfter(date, academicYearCutoff);
	if (isFallTerm) {
		yearsFromGraduation--;
	}
	return yearsFromGraduation;
}
